import defineService from './defineService';
import {setAuthState} from './authorize';

const postLogin = defineService('post', 'api/v1/auth/api-token-auth/', {
  alternatives: {altWrongPw: '-wrongpw-400'}
});
const postRegister = defineService('post', 'api/v1/auth/register-lazy-user/');
const postPasswordReset = defineService('post', 'api/v1/rest-auth/password/reset/');
const postPasswordResetConfirm = defineService('post', 'api/v1/rest-auth/password/reset/confirm/');
const postSocialAuth = defineService('post', 'rest-auth/:provider/');
const postLogout = defineService('post', 'rest-auth/logout/');
const postImpersonate = defineService('post', 'api/v1/auth/api-token-impersonate/');
export const getUser = defineService('get', 'api/v1/user/');

export async function login(username, password) {
  try {
    let data = await postLogin({username, password});
    return setAuthState(data);
  } catch(e) {
    console.log(e);
    if (e.response && e.response.data && e.response.data.details) {
      throw  e.response.data.details;
    }
    throw e;
  }
}

export function logout() {
  postLogout({});
  setAuthState({});
}

export async function signUp({email, password, first_name, last_name, team, token}) {
  let data = await postRegister({username: email, email, password, first_name, last_name, team, token});
  return setAuthState(data);
}

export async function resetPassword(email) {
  let {detail} = await postPasswordReset({email});
  return detail;
}

export async function confirmReset(params) {
  console.log('confirmReset', params);
  try {
    return await postPasswordResetConfirm(params);
  } catch(e) {
    console.log(e);
    if (e.response && e.response.data) {
      throw e.response.data;
    }
    throw e.toString();
  }
}

export async function socialAuth(provider, {access_token, code}) {
  var data = await postSocialAuth(provider, {access_token, code});
  console.log(data);
  return setAuthState(data);
}

export async function impersonate(username) {
  var data = await postImpersonate({username});
  return setAuthState(data);
}



// WEBPACK FOOTER //
// ./src/services/accounts.js